import { render, staticRenderFns } from "./ApprovalSettingWizard.vue?vue&type=template&id=b7478c48&"
import script from "./ApprovalSettingWizard.vue?vue&type=script&lang=js&"
export * from "./ApprovalSettingWizard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports